import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import styled from 'styled-components'

import FilterTitle from './FilterTitle'
import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  display: flex;
  flex-flow: column;
  border-bottom: 1px solid ${colors.secondary70};
`

const StyledInput = styled.input`
  && {
    margin: 0 10px 10px 9px;
    width: auto;
    height: 30px;
    font-size: 14px;
    padding-left: 12px;
    outline: none;
    color: ${colors.secondary20};
    border-radius: 3px;
    border: 1px solid ${colors.secondary70};

    &:focus {
      border: 1px solid ${colors.primary40};
    }
  }
`

const StyledTextArea = styled.textarea`
  && {
    padding: 5px;
    margin: 0 10px 10px 9px;
    width: auto;
    height: 50px;
    font-size: 14px;
    outline: none;
    color: ${colors.secondary20};
    border-radius: 3px;
    border: 1px solid ${colors.secondary70};
    resize: vertical;

    &:focus {
      border: 1px solid ${colors.primary40};
    }
  }
`

const FilterSectionText = ({ title, name, value, onChange, multiline }) => {
  const active = !!value
  const [value_, setValue_] = useState(value || '')
  const isEmpty = !value_

  useEffect(() => {
    setValue_(value || '')
  }, [value])

  const onActiveChange = (newActive) => {
    applyChanges(newActive ? value_ : '')
  }

  const onInputChange = (e) => {
    setValue_(e.target.value)
  }

  const onBlur = () => {
    if (active) {
      applyChanges(value_)
    }
  }

  const applyChanges = (newValue) => {
    onChange?.({
      value: newValue,
      name: name,
    })
  }

  const onKeyPress = (e) => {
    if (e.key === 'Enter' && active) {
      applyChanges(value_)
    }
  }

  const renderInput = () => {
    if (multiline) {
      return (
        <StyledTextArea
          value={value_}
          placeholder='Enter value'
          onChange={onInputChange}
          onBlur={onBlur}
        />
      )
    } else {
      return (
        <StyledInput
          type='text'
          value={value_}
          placeholder='Enter value'
          onChange={onInputChange}
          onBlur={onBlur}
          onKeyPress={onKeyPress}
        />
      )
    }
  }

  return (
    <StyledWrapper data-test={name}>
      <FilterTitle
        disabled={isEmpty}
        active={active}
        title={title}
        onActiveChange={onActiveChange}
      />
      {renderInput()}
    </StyledWrapper>
  )
}

FilterSectionText.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  multiline: PropTypes.bool,
}

export default FilterSectionText
